import StatsContainer from "./StatsContainer";
import StatsStore from "./StatsStore";

export default StatsStore(StatsContainer);